import { extractMailboxEmail } from './messageParticipants';

interface ReplyMessage {
  id: string;
  from: string;
  to?: string | null;
  replyTo?: string | null;
  subject?: string | null;
  receivedAt: string;
  imapFolder?: { specialUse?: string | null } | null;
  replies?: ReplyMessage[];
}

export function createReplyComposer(message: ReplyMessage) {
  const outgoingRoot = message.imapFolder?.specialUse === '\\Sent';
  const ownAddress = extractMailboxEmail(outgoingRoot ? message.from : message.to).toLowerCase();
  const incoming = [message, ...(message.replies || [])]
    .sort((a, b) => new Date(b.receivedAt).getTime() - new Date(a.receivedAt).getTime())
    .find(item => item.imapFolder?.specialUse !== '\\Sent'
      && (!ownAddress || extractMailboxEmail(item.from).toLowerCase() !== ownAddress));
  const target = incoming || message;
  return {
    to: !incoming && outgoingRoot ? extractMailboxEmail(message.to) : extractMailboxEmail(target.replyTo) || extractMailboxEmail(target.from),
    cc: '', bcc: '', subject: `Re: ${message.subject || ''}`, bodyHtml: '', parentId: message.id,
  };
}

export function replyMatchesSelection(ownerId: string, selectedId?: string | null): boolean {
  return Boolean(ownerId && ownerId === selectedId);
}
